import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

//pages
import Home from "./Pages/Home/";
import Landing from "./Pages/Landing";
import Training from "./Pages/Training/Training";
import ReportCard from "./Pages/ReportCard";
import ViewReportCard from "./Pages/ReportCard/Components/ViewCard";
import LearningPrograms from "./Pages/LearningPrograms";
import ProgramDetail from "./Pages/ProgramDetail";
import StudentManagement from "./Pages/StudentManagement";
import QuizProgramDetail from "./Pages/LearningPrograms/QuizProgramDetails";
import ChampionDetails from "./Pages/LearningPrograms/ProgramDetail/Components/ChampionDetails";
import StudentAchievements from "./Pages/StudentAchievements";
import Organiser from "./Pages/OrganizerCommunications";
import ContactUs from "./Pages/ContactUs";
import Assessments from "./Pages/Assessments";
import AdministrativeControls from "./Pages/AdministrativeControls";

import PrivateRoutes from "./helper/PrivateRoutes";
import MissingRoute from "./Pages/MissingRoute";
import HowToUse from "./Pages/HowToUse";

const AppRoutes = () => {
  return (
    <Router basename="/school-dashboard">
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route element={<PrivateRoutes />}>
          <Route path="/dashboard" element={<Home />} />
          <Route path="/training" element={<Training />} />
          <Route path="/report-card" element={<ReportCard />} />
          <Route path="/view-reportcard" element={<ViewReportCard />} />
          <Route path="/learning-programs" element={<LearningPrograms />} />
          <Route path="/learning-programs/:event_code" element={<ProgramDetail />} />
          <Route path="/student-management" element={<StudentManagement />} />
          <Route path="/quiz-program-detail" element={<QuizProgramDetail />} />
          <Route path="/champion-details" element={<ChampionDetails />} />
          <Route path="/student-achievements" element={<StudentAchievements />} />
          <Route path="/organizer-communications" element={<Organiser />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/assessments" element={<Assessments />} />
          <Route path="/administrative-controls" element={<AdministrativeControls />} />
          <Route path="/how-to-use" element={<HowToUse />} />
        </Route>
        <Route path="*" element={<MissingRoute />} />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
